'use client';

import { useEffect } from 'react';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const msg = [error?.message, error?.digest].filter(Boolean).join(' — ');
    console.error('Application client error', msg || error);
  }, [error]);

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 px-6 py-16 text-center">
      <h1 className="text-lg font-semibold text-slate-900">Une erreur s’est produite</h1>
      <p className="text-sm text-slate-600 max-w-md">
        Le chargement de cette page a échoué. Vous pouvez réessayer ou revenir en arrière.
        {process.env.NODE_ENV === 'development' && error?.message ? (
          <span className="mt-2 block font-mono text-xs text-rose-700 break-words">
            {error.message}
          </span>
        ) : null}
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <button
          type="button"
          onClick={() => reset()}
          className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
        >
          Réessayer
        </button>
        <a
          href="/notification-feed"
          className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-800 hover:bg-slate-50"
        >
          Accueil
        </a>
      </div>
    </div>
  );
}
